// Pflegehilfe fuer den Blueprint productHotspots (#239321).
// Aktiv nur mit ?hotspots=edit in der URL. Statt x/y-Werte zu schaetzen, klickt
// die Redaktion ins Bild: die Position wird als "x;y" (Prozent, 1 Nachkomma-
// stelle) angezeigt und in die Zwischenablage kopiert. Vorhandene Hotspots
// tragen ihre Nummer (= Feld hotspot1-3) und lassen sich verschieben; danach
// wird die neue Position "x;y" kopiert. Modals und Slider-Swipe sind im
// Editiermodus deaktiviert. Am Datenmodell aendert sich nichts.

const PARAM = 'hotspots';
const PARAM_VALUE = 'edit';
const DRAG_THRESHOLD = 3;

function round(value) {
  return Math.round(Math.min(100, Math.max(0, value)) * 10) / 10;
}

function positionIn(slide, event) {
  const rect = slide.getBoundingClientRect();
  return {
    x: round(((event.clientX - rect.left) / rect.width) * 100),
    y: round(((event.clientY - rect.top) / rect.height) * 100),
  };
}

function createPanel() {
  const panel = document.createElement('div');
  panel.className = 'productHotspotsEditorPanel';
  panel.innerHTML = `
    <p class="productHotspotsEditorPanel__title">Hotspot-Editor</p>
    <p class="productHotspotsEditorPanel__hint">Ins Bild klicken = Position kopieren. Nummerierte Punkte ziehen = verschieben.</p>
    <label class="productHotspotsEditorPanel__label">
      Zuletzt kopiert
      <input class="productHotspotsEditorPanel__value js-productHotspotsEditorValue" type="text" readonly value="">
    </label>
    <p class="productHotspotsEditorPanel__status js-productHotspotsEditorStatus" aria-live="polite"></p>
  `;
  document.body.appendChild(panel);

  const input = panel.querySelector('.js-productHotspotsEditorValue');
  input.addEventListener('focus', () => input.select());

  return {
    input,
    status: panel.querySelector('.js-productHotspotsEditorStatus'),
  };
}

function copy(panel, value, context) {
  panel.input.value = value;

  const done = (ok) => {
    panel.status.textContent = ok
      ? `${context} kopiert: ${value}`
      : `${context}: ${value} (bitte manuell kopieren)`;
    if (!ok) {
      panel.input.focus();
    }
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(value).then(() => done(true), () => done(false));
  } else {
    done(false);
  }
}

function showMarker(slide, pos) {
  let marker = slide.querySelector('.productHotspots__editMarker');
  if (!marker) {
    marker = document.createElement('span');
    marker.className = 'productHotspots__editMarker';
    marker.setAttribute('aria-hidden', 'true');
    slide.appendChild(marker);
  }
  marker.style.left = `${pos.x}%`;
  marker.style.top = `${pos.y}%`;
  marker.dataset.value = `${pos.x};${pos.y}`;
}

function setupHotspot(btn, panel) {
  const badge = document.createElement('span');
  badge.className = 'productHotspots__editBadge';
  badge.textContent = btn.dataset.hotspotIndex || '?';
  btn.appendChild(badge);

  let drag = null;

  btn.addEventListener('pointerdown', (event) => {
    const slide = btn.closest('.productHotspots__slide');
    if (!slide) return;
    event.preventDefault();
    btn.setPointerCapture(event.pointerId);
    drag = { slide, startX: event.clientX, startY: event.clientY, moved: false };
  });

  btn.addEventListener('pointermove', (event) => {
    if (!drag) return;
    if (!drag.moved && Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) < DRAG_THRESHOLD) {
      return;
    }
    drag.moved = true;
    btn.classList.add('is-dragging');
    const pos = positionIn(drag.slide, event);
    btn.style.left = `${pos.x}%`;
    btn.style.top = `${pos.y}%`;
    drag.pos = pos;
  });

  const finish = () => {
    if (!drag) return;
    btn.classList.remove('is-dragging');
    const index = btn.dataset.hotspotIndex || '?';
    if (drag.moved && drag.pos) {
      const value = `${drag.pos.x};${drag.pos.y}`;
      btn.dataset.hotspot = value;
      copy(panel, value, `Position Hotspot ${index}`);
    } else {
      const current = (btn.dataset.hotspot || '').split(';').slice(0, 2).join(';');
      copy(panel, current, `Position Hotspot ${index}`);
    }
    drag = null;
  };

  btn.addEventListener('pointerup', finish);
  btn.addEventListener('pointercancel', finish);
}

function setupRoot(root, panel) {
  root.classList.add('is-hotspotEditing');

  const container = root.querySelector('.js-productHotspotsSwiper');
  if (container && container.swiper) {
    container.swiper.allowTouchMove = false;
  }

  root.querySelectorAll('.js-productHotspotsHotspot').forEach((btn) => setupHotspot(btn, panel));

  // Capture-Phase: Hotspot-Klicks duerfen im Editiermodus kein Modal oeffnen
  root.addEventListener('click', (event) => {
    if (event.target.closest('.js-productHotspotsHotspot')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const slide = event.target.closest('.productHotspots__slide');
    if (!slide || event.target.closest('dialog')) return;

    const pos = positionIn(slide, event);
    showMarker(slide, pos);
    copy(panel, `${pos.x};${pos.y}`, 'Position');
  }, true);
}

export function initProductHotspotsEditor() {
  if (new URLSearchParams(window.location.search).get(PARAM) !== PARAM_VALUE) {
    return;
  }

  const roots = document.querySelectorAll('.js-productHotspots');
  if (!roots.length) {
    return;
  }

  const panel = createPanel();
  roots.forEach((root) => setupRoot(root, panel));

  // Aufruf aus dem CMS-Link: direkt zum (ersten) Slider springen
  roots[0].scrollIntoView({ block: 'center' });
}
